import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { toast } from "react-toastify";
import Matches from "./matches";
import Standings from "./standings";
import TournamentApi from "../api/tournamentApi";
import UserControls from "./userControls";

class Tournament extends Component {
  constructor(props) {
    super(props);

    this.state = {
      eventId: props.params.id,
      eventName: "",
      version: -1,
      scoreTypeId: "tournament-15",
      standings: [],
      allMatches: [],
      setScoreMatches: [],
      sessionId: localStorage.getItem("atsSessionId"),
      isAdmin: localStorage.getItem("atsIsAdmin") === "true",
      validNewRoundRequests: [],
      scoreData: { matchId: "", scoreId: "" },
      processing: false,
    };
  }

  async componentDidMount() {
    await this.refreshData();

    this.interval = setInterval(async () => this.refreshData(), 3000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  refreshData = async () => {
    const { eventId, version } = this.state;
    const { status, data: tournamentInfo, message } = await TournamentApi.getTournament(eventId, version);

    if (status === 204) return;

    if (status !== 200) {
      toast.error(message);
      return;
    }

    this.setState({
      eventName: tournamentInfo.name,
      standings: tournamentInfo.standings,
      allMatches: tournamentInfo.allMatches,
      setScoreMatches: tournamentInfo.setScoreMatches,
      version: tournamentInfo.version,
      scoreTypeId: tournamentInfo.scoreTypeId,
      validNewRoundRequests: tournamentInfo.validNewRoundRequests,
    });
  };

  handleNewRound = async (r) => {
    this.setState({ processing: true });

    const { success, data: response, message } = await TournamentApi.postNewRound(this.state.eventId, r);

    this.setState({ processing: false });

    if (!success) {
      toast.error(message);
      return;
    }

    toast(r.type === 4 ? "Last round deleted" : "New round created");

    this.setState({
      allMatches: [...this.state.allMatches, ...response.matches],
      setScoreMatches: [...this.state.setScoreMatches, ...response.matches],
      validNewRoundRequests: [],
    });
  };

  handleNewScore = async () => {
    this.setState({ processing: true });

    const { eventId, scoreData } = this.state;
    const { data: tournamentInfo, status, message } = await TournamentApi.postNewScore(eventId, scoreData);

    this.setState({ processing: false });

    if (status === 200) {
      this.setState({
        eventName: tournamentInfo.name,
        standings: tournamentInfo.standings,
        allMatches: tournamentInfo.allMatches,
        setScoreMatches: tournamentInfo.setScoreMatches,
        scoreData: { matchId: "", scoreId: "" },
        validNewRoundRequests: tournamentInfo.validNewRoundRequests,
      });
      toast("Score processed and standings are updated");
    } else if (status === 202) {
      this.setState({ scoreData: { matchId: "", scoreId: "" } });
      toast("Score accepted, waiting for score from your opponent");
    } else if (status === 409) {
      toast.error("Score you entered conflicts with your opponent's");
    } else {
      toast.error(message);
    }
  };

  handleChange = (e) => {
    const scoreData = { ...this.state.scoreData };
    scoreData[e.currentTarget.id] = e.currentTarget.value;
    this.setState({ scoreData });
  };

  render() {
    return (
      <>
        <Modal show={this.state.processing} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Body>Processing...</Modal.Body>
        </Modal>
        <Container fluid>
          <Row className="g-0">
            <Col>
              <h1>
                {this.state.eventName}
                {this.state.sessionId && (
                  <UserControls
                    onNewRound={this.handleNewRound}
                    onNewScore={this.handleNewScore}
                    onChange={this.handleChange}
                    matches={this.state.setScoreMatches}
                    scoreTypeId={this.state.scoreTypeId}
                    data={this.state.scoreData}
                    validNewRoundRequests={this.state.validNewRoundRequests}
                  />
                )}
              </h1>
            </Col>
          </Row>
          <Row className="g-0">
            <Col>
              <Standings standings={this.state.standings} />
            </Col>
          </Row>
          <Row className="g-0">
            <Col>
              <Matches matches={this.state.allMatches} />
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Tournament;
